import { parseQueryString, scrollToActiveElementOnMount } from '../index';

export const addHashValueFromHashRedirect = (history) => {
  try {
    const queries = parseQueryString(history.location.search);
    if (queries.hashRedirect) {
      const hash = queries.hashRedirect;
      const newQuery = Object.entries(queries).reduce((acc, [key, val]) => {
        if (key === 'hashRedirect') {
          return acc + '';
        }
        return acc + `${key}=${val}`;
      }, '');
      history.push(`#${hash}${newQuery ? '?' + newQuery : ''}`);
      scrollToActiveElementOnMount(history.location);
    }
  } catch (e) {
    console.log('hashRedirect failed silently::', e);
  }
};
